import { render, staticRenderFns } from "./SectionPartners.vue?vue&type=template&id=20886a4a&scoped=true"
import script from "./SectionPartners.vue?vue&type=script&lang=js"
export * from "./SectionPartners.vue?vue&type=script&lang=js"
import style0 from "./SectionPartners.vue?vue&type=style&index=0&id=20886a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20886a4a",
  null
  
)

export default component.exports